import { useHistory, useParams } from "react-router-dom";
import { useState } from "react";

import { assessmentRequestsTyped } from "@/api/(requests)/assessmentTyped";
import { Button2 } from "@/ui2/atoms/Button";
import { captureErrorMessage, parseError } from "@/lib/helpers/captureErrorMessage";
import { useLogInTaskContext } from "@/portals/(patient)/(login-tasks)/LogInTaskContext";
import { usePreventLeaveSite } from "@/lib/hooks/usePreventLeaveSite";

import { CancellationModal } from "./CancellationModal";

export function AssessmentCancelButton({
  isDirty,
  isSubmitting,
}: {
  isDirty?: boolean;
  isSubmitting?: boolean;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  /** Detect if is used as login task and the task needs to be redux-skipped */
  const { task_name } = useParams<{ task_name?: string }>();
  const isLoginTask = !!task_name;
  const buttonText = isLoginTask ? "Skip For Now" : "Cancel";
  const SecondaryCTA = isLoginTask ? () => <SkipLoginTask taskName={task_name} /> : Cancel;

  const shouldPreventNavigation = isDirty && !isSubmitting;

  usePreventLeaveSite({
    isEnabled: shouldPreventNavigation,
  });

  return (
    <>
      <Button2 onPress={() => setIsModalOpen(true)} type="button" variant="secondary">
        {buttonText}
      </Button2>

      <CancellationModal
        isModalOpen={isModalOpen}
        SecondaryCTA={SecondaryCTA}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
}

function Cancel() {
  const history = useHistory();

  return (
    <Button2 onPress={() => history.push("/app/home")} size="md" variant="secondary">
      Leave
    </Button2>
  );
}

function SkipLoginTask({ taskName }: { taskName?: string }) {
  const { onTaskSkipped, task } = useLogInTaskContext();

  // TODO: convert to TQ once full skip logic is implemented
  const handleSkip = () => {
    // don't await the request, fire and forget
    assessmentRequestsTyped.skip_task({ urlParams: { taskId: task.task_id } }).catch((error) => {
      captureErrorMessage(parseError({ error, fallback: "Failed to skip assessment task" }), {
        tags: {
          component: "AssessmentCancelButton",
          errorType: "skip_task",
          taskId: task.task_id,
          taskName,
        },
      });
    });

    onTaskSkipped();
  };

  return (
    <Button2 onPress={handleSkip} size="md" variant="secondary">
      Leave
    </Button2>
  );
}
